<template lang="html">
  <div>
    <br>
    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Descrição dos resultados do projeto de pesquisa -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Descrição dos resultados do projeto de pesquisa" 
            :value="this.projetoPesquisa.resultadosObtidos ? this.projetoPesquisa.resultadosObtidos : '-'"  
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Arquivos com resultados do projeto -->
        <v-layout row v-if="listaArquivosFiltrada.length !== 0">
          <v-flex xs12>
            <label>Arquivos com resultados do projeto</label>
          </v-flex>
        </v-layout>

        <!-- Tabela com os arquivos -->
        <v-layout row v-if="listaArquivosFiltrada.length !== 0">
          <v-flex xs12>
            <v-data-table
              class="elevation-1 arquivos"
              :headers="headersArquivos"
              :header-props="{ sortIcon: null }"
              :items="listaArquivosFiltrada"
              :items-per-page="-1"
              hide-default-footer
            >

              <!-- Formata o nome do arquivo -->
              <template v-slot:item.nome="props">
                <a :href="api_url + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + props.item.idArquivo">
                  <v-icon>vertical_align_bottom</v-icon>{{ props.item.nome.trim() }}
                </a>
              </template>

            </v-data-table>
          </v-flex>
        </v-layout>

        <!-- Caso o projeto não tenha arquivos com resultados do projeto -->
        <v-layout row v-if="listaArquivosFiltrada.length === 0">
          <v-flex xs12>
            <c-readonly-field
              label="Arquivos com resultados do projeto"
              value="-"
              align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <br>

      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Editar" -->
      <v-btn color="primary" @click="toEditar()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Editar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
import projetos from '@/utils/projetos'
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    listaArquivos: [],
    listaArquivosFiltrada: [],
    api_url: process.env.API_BASE_URL,
    headersArquivos: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Observação', align: 'left', value: 'observacao' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaContatos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Função que filtra os arquivos que são do tipo "Resultado do projeto" (item = 2).
    filtroTipoArquivoResultadoProjeto: function (arquivo) {
      if ('tipoArquivo' in arquivo && arquivo.tipoArquivo.item === 2) {
        return true
      } else {
        return false
      }
    },

    // Carrega os arquivos do projeto de pesquisa e filtra os arquivos que são do tipo "Resultado do projeto".
    carregaArquivosProjetoPesquisa: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos com resultados do projeto...' })
      projetos.getArquivosProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.listaArquivos = response.data.slice()
        this.listaArquivosFiltrada = this.listaArquivos.filter(this.filtroTipoArquivoResultadoProjeto)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos com resultados do projeto...' })
      })
    },

    // Edita a aba "Resultados obtidos".
    toEditar: function () {
      this.$router.push({ name: 'EditarProjetoPesquisaResultadosObtidos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    }
  },
  mounted () {
    // Carrega os arquivos do projeto de pesquisa.
    this.carregaArquivosProjetoPesquisa()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-readonly-field': ReadonlyField
  }
}
</script>

<style scoped>

  .arquivos {
    margin-top: 1em;
    margin-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// resultados-obtidos.vue?7b8cdade